module.exports = __webpack_public_path__ + "a6e2499083fdb344cb1e3637599d7e20.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/happy-12.png
// module id = 1523
// module chunks = 0